import React, {useEffect, useState} from 'react';
import {Button, Input, Loader, ModalRequest, Select} from "../common";
import {BUTTON_TYPES} from "../../types";
import {useQuery} from "react-query";

interface IProducts {
  types?: Array<{
    name?: string;
    label?: string
  }>
}

const FilterModals = (
  { open, onClose, applyData }: { open: boolean; onClose: () => void; applyData: (data: any) => void; }
) => {
  const [activeProduct, setActiveProduct] = useState<
    { id?: string | number; label?: string }
  >({ id: 'Все', label: 'Все' });
  const [activeBank, setActiveBank] = useState<
    { id?: string | number; label?: string }
  >({ id: 'Все', label: 'Все' });

  const [dateStart, setDateStart] = useState<string>('');
  const [dateEnd, setDateEnd] = useState<string>('');
  const [productData, setProductData] = useState<Array<any>>([]);
  const [banksData, setBanksData] = useState<Array<any>>([]);

  const { data: products, isLoading }: {
    data: IProducts | undefined; isLoading: boolean;
  } = useQuery(["statisticsProducts"], {
    refetchOnWindowFocus: false
  });

  const { data: banks, isLoading: loading }: {
    data?: Array<{ id: string | number; full_name: string }> | undefined; isLoading: boolean;
  } = useQuery(["statisticsBanks"], {
    refetchOnWindowFocus: false
  });

  useEffect(() => {
    const arrayOfProduct: Array<any> = [
      { id: 'Все', label: 'Все'}
    ];

    products?.types?.forEach(i => {
      const obj = {
        id: i?.name,
        label: i?.label,
      };

      arrayOfProduct.push(obj)
    });

    setProductData([...arrayOfProduct]);

  }, [products])

  useEffect(() => {
    const arrayOfBanks: Array<any> = [
      { id: 'Все', label: 'Все'}
    ];

    banks?.forEach(i => {
      const obj = {
        id: i?.id,
        label: i?.full_name,
      };

      arrayOfBanks.push(obj)
    });

    setBanksData([...arrayOfBanks]);

  }, [banks])

  const handleSelectProduct = (label: string) => {
    if (label === 'Все') {
      setActiveProduct({ id: label, label: label});
    }

    const selected = products?.types?.find(i => i.name === label);

    if (selected) {
      setActiveProduct({ id: selected.name, label: selected.label});
    }
  }

  const handleSelectBank = (label: string) => {
    if (label === 'Все') {
      setActiveBank({ id: label, label: label});
    }

    const selected = banks?.find(i => i.id === label);

    if (selected) {
      setActiveBank({ id: selected.id, label: selected.full_name});
    }
  }

  const resetData = () => {
    const defaultValue = {
      id: 'Все',
      label: 'Все',
    };

    setActiveBank(defaultValue)
    setActiveProduct(defaultValue)
    setDateStart('');
    setDateEnd('');
  }

  const handleCancel = () => {
    onClose();
    resetData();
  }

  const handleApply = () => {
    const data = {
      start: dateStart,
      end: dateEnd,
      bank: activeBank.id,
      product: activeProduct.id
    }

    applyData(data);
    onClose();
  }

  return (
    <ModalRequest open={open} onClose={onClose} title="Фильтры">
      <>
        {isLoading || loading && <Loader />}
        <p className="text-[14px] leading-[24px] text-black font-medium mb-1">Категория продуктов</p>
        <Select
          value={productData}
          activeData={activeProduct}
          onChange={(e) => handleSelectProduct(e)}
        />

        <p className="text-[14px] leading-[24px] text-black font-medium mb-1 mt-4">Банк</p>
        <Select
          value={banksData}
          activeData={activeBank}
          onChange={(e) => handleSelectBank(e)}
        />

        <p className="text-[14px] leading-[24px] text-black font-medium mb-1 mt-4">Период</p>
        <div className="flex items-center gap-2">
          <Input
            onChange={(e) => setDateStart(e.target.value)}
            value={dateStart}
            type="date"
            className="w-full"
          />
          <Input
            onChange={(e) => setDateEnd(e.target.value)}
            value={dateEnd}
            type="date"
            className="w-full"
          />
        </div>

        <div className="mt-6 flex items-center gap-2 lg:flex-col">
          <Button
            title={'Применить'}
            type={BUTTON_TYPES.SECONDARY}
            onClick={handleApply}
            className="lg:w-full"
          />
          <Button
            title={'Сбросить'}
            type={BUTTON_TYPES.SECONDARY}
            onClick={resetData}
            className="lg:w-full"
          />
          <Button
            title={'Отмена'}
            type={BUTTON_TYPES.GRAY}
            onClick={handleCancel}
            className="lg:w-full"
          />
        </div>
      </>
    </ModalRequest>
  )
};

export default FilterModals;
